import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RestApi } from '../../auth/rest.api';
import { IEnvironmentConfiguration } from '../models/environment-configuration';
import { IEnvironment } from '../models/environment';
import { CryptographyKeyUrl } from '../models/environment-parameters';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class EnvironmentDataService {

  private api_environment_GetCurrentEnvironment = 'api/Environment/GetEnvironment';
  private api_environment_UpdateEnvironment = 'api/Environment/UpdateEnvironment';
  private api_environment_GetMetadata = 'api/Environment/Metadata';
  private api_environment_GetSMSProviders = 'api/Environment/SMS/Providers';
  private api_environment_GetCountryCodeNumbers = 'api/Environment/Country/CodeNumbers';
  private api_environment_GetConfiguration = 'api/Environment/EmailConfiguration';
  private api_environment_GetCertificate = 'api/Environment/GetCertificateDate';
  private api_environment_UpdateCertificate = 'api/Environment/UpdateCertificateDate';
  private api_environment_GetConfigurationDefault = 'api/Environment/GetDefaultEmailConfiguration';
  private api_environment_GetWSSecurityKey = 'api/Environment/GetKeyWsSecurity';
  private api_environment_DownloadCertificate = 'api/Environment/DownloadCertificate';

  constructor(private _authHttp: RestApi) { }

  getEnvironmentConfiguration(): Observable<IEnvironmentConfiguration> {
    return this._authHttp.get(this.api_environment_GetCurrentEnvironment)
      .map((response: Response) => {
        let environmentConfiguration: IEnvironmentConfiguration;
        const environments: IEnvironment[] = new Array<IEnvironment>();

        environmentConfiguration = (response[0] as IEnvironmentConfiguration);
        environmentConfiguration.environments = [];

        const contenEnvironmentConfg = environmentConfiguration.content;
        environmentConfiguration.customMetadata = contenEnvironmentConfg.customMetadata;
        const currentEnvironments = JSON.parse(contenEnvironmentConfg.environments);
        currentEnvironments.forEach(environment => {
          environment.parameters.cryptographyKeyUrlFormat = JSON.parse(
            environment.parameters.cryptographyKeyUrl
          ) as CryptographyKeyUrl;
          environmentConfiguration.environments.push(environment as IEnvironment);
        });
        return environmentConfiguration;
      });
  };

  saveEnvironmentConfiguration(environmentConfiguration: IEnvironmentConfiguration[]) {
    const json = JSON.stringify(JSON.stringify(environmentConfiguration));
    return this._authHttp.post(this.api_environment_UpdateEnvironment, environmentConfiguration);
  };

  getEnvironmentMetadata(): Promise<any> {
    return this._authHttp.get(this.api_environment_GetMetadata).toPromise();
  };

  getEmailConfiguration() {
    return this._authHttp.get(this.api_environment_GetConfiguration);
  }

  downloadCertificate(nameFile) {
    return this._authHttp.requestBlob(
      {
        url: this.api_environment_DownloadCertificate,
        parameters: [],
        body: []
      }, 'POST')
      .map(result => {
        const fileName: string = this._authHttp.getFileNameFromHeaders(result.headers, nameFile);
        const pdfUrl = (window.URL || window['webkitURL']).createObjectURL(new Blob([result.body], { type: 'application/octet-stream' }));
        const anchor = document.createElement('a');
        anchor.download = fileName;
        anchor.href = pdfUrl;
        anchor.click();
      });
  }

  getCertificate() {
    return this._authHttp.get(this.api_environment_GetCertificate);
  }

  updateCertificate() {
    return this._authHttp.get(this.api_environment_UpdateCertificate);
  }

  getEmailDefaultWebConfig() {
    return this._authHttp.get(this.api_environment_GetConfigurationDefault);
  }

  getWSSecurityKey() {
    return this._authHttp.get(this.api_environment_GetWSSecurityKey);
  }

  getSMSProviders(): Promise<any> {
    return this._authHttp.get(this.api_environment_GetSMSProviders).toPromise();
  };

  getCountryCodeNumbers(): Promise<any> {
    return this._authHttp.get(this.api_environment_GetCountryCodeNumbers).toPromise();
  };

}
